// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__Rj2ox","header":"PatientQuestionnaire_header__twEk1","info":"PatientQuestionnaire_info__21vAF"};